import { render, staticRenderFns } from "./old-to-new.vue?vue&type=template&id=70666b26&"
import script from "./old-to-new.vue?vue&type=script&lang=js&"
export * from "./old-to-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports